import {ExcelUpload} from "../ExcelUpload";

export const CountUpload = () => {
  return (
    <div className="p-8">
      <ExcelUpload
        title="Upload Hutch Message Count (Excel)"
        uploadUrl={`${process.env.REACT_APP_API_V2_URL}content-count/upload`}
      />
    </div>
  );
};
